// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


Vue.config.productionTip = false
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
import myaxios from './utils/myaxios'
import store from "./utils/store";
import utils from "./utils/utils";
import waterfall from 'vue-waterfall2'
Vue.use(waterfall)
Vue.prototype.$axios = myaxios;
Vue.prototype.$utils = utils;
/* eslint-disable no-new */
import Clipboard from 'vue-clipboard2'
// Vue.directive('clipboard', {
//   inserted: function (el, binding) {
//     el.style.cursor = 'pointer';
//     new Clipboard(el, {
//       text: function () {
//         return binding.value;
//       }
//     });
//   }
// })
Vue.use(Clipboard)
new Vue({
  el: '#app',
  router,
  store:store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js